module.exports = __webpack_public_path__ + "img/values-responsiveness.51f83f8d.gif";